<div *ngIf="isLoading" class="loader">
  <div class="spinner"></div>
  <p>Loading...</p>
</div>

<div *ngIf="!isLoading">
  <div *ngIf="!noBanner">
    <owl-carousel-o *ngIf="banners.length > 0" [options]="customOptions" class="my-carosal" id="owl-carousel" (change)="slide($event)">
      <ng-container *ngFor="let item of banners;let i=index">
        <ng-template carouselSlide [id]="item.value.title">
          <div class="carousel-item active" style="width: 100vw !important;">
            <img [src]="item.value.featured_image.large" class="d-block w-100" alt="...">
            <div class="carousel-caption d-md-block text-left" *ngIf="reload">
              <h1 class="animate__animated animate__fadeInDown " style="font-size: 0.6rem">{{item.value.title}}</h1>
              <p class="animate__animated animate__fadeInUp mb-0" style="font-size: 0.6rem">{{item.value.content}}</p>
            </div>
          </div>    
      </ng-template>  
      </ng-container>
    </owl-carousel-o>
  </div>
  
  <div *ngIf="noBanner">
    <div *ngFor="let banner of defaultBanner;let i=index">
      <img [src]="banner?.image" class="d-block w-100" alt="...">
    </div>
    
    <!-- <owl-carousel-o  [options]="customOptions">
      <ng-template carouselSlide *ngFor="let banner of defaultBanner;let i=index">
        <div class="carousel-item active"  >
            <img [src]="banner?.image" class="d-block w-100" alt="...">
            <div class="carousel-caption d-none d-md-block text-left" >
              <h1 class="animate__animated animate__fadeInDown ">{{banner?.title}}</h1>
              <p class="animate__animated animate__fadeInLeft ">{{banner?.content}}</p>
            </div>
        </div>
      </ng-template>  
    </owl-carousel-o> -->
  </div>
  
</div>